import { Component } from '@angular/core';
import { Platform, NavController, ToastController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { Storage } from '@ionic/storage';

import { LoginPage } from '../../pages/login/login';

import { AuthProvider } from '../../providers/auth';

@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html',
})
export class ChangePasswordPage {

  requestPasswordForm : FormGroup;
  passwordCodeForm : FormGroup;
  changePasswordForm : FormGroup;

  requestedCode: boolean = false;
  codeWasValid: any = false;

  isRequesting: boolean = false;
  isValidating: boolean = false;
  isChanging: boolean = false;

  recievedError: boolean = false;

  constructor(
      public platform: Platform, 
      public navCtrl: NavController,
      public formBuilder: FormBuilder,
      public toastCtrl: ToastController,
      public storage: Storage,  
      public authProvider: AuthProvider,
      public alertCtrl: AlertController
              ) {    
     this.requestPasswordForm = this.formBuilder.group({
      "username":  ['', Validators.compose([Validators.required, Validators.email])]
     });      

    this.passwordCodeForm = this.formBuilder.group({
      "passwordCode":  ['', Validators.required],
      "username": ''
     });     

     this.changePasswordForm = this.formBuilder.group({
      "grant_type": ['password'],
      "password":  ['', Validators.required],
      "username": '',
      "passwordCode": ''
     });    
  }

  ionViewWillEnter() {
  }  

  requestPasswordCode() {
    if(this.isRequesting) return;

    this.isRequesting = true;

    this.authProvider.requestPasswordChange(this.requestPasswordForm.value)
    .then( data => {        
        this.requestedCode = true;
        this.isRequesting = false;
    })
    .catch( error => {
        this.isRequesting = false;
        this.recievedError = true;
        console.log(error)
    })
  }

  validatePasswordCode() {
    if(this.isValidating) return;

    this.isValidating = true;

    this.passwordCodeForm.patchValue({
            "username": this.requestPasswordForm.value.username
    })

    this.authProvider.validatePasswordCode(this.passwordCodeForm.value)
    .then( data => {        

        this.codeWasValid = data;
        this.isValidating = false;
    })
    .catch( error => {
        this.isValidating = false;
        this.recievedError = true;
        console.log(error)
    })
  }

  changePassword() {
    if(this.isChanging) return;

    this.isChanging = true;

    this.changePasswordForm.patchValue({
            "username": this.requestPasswordForm.value.username,
            "passwordCode": this.passwordCodeForm.value.passwordCode
    })

    this.authProvider.changePassword(this.changePasswordForm.value)
    .then( succeeded => {        

        if(succeeded) {

          this.isChanging = false;

          let confirm = this.alertCtrl.create({
            title: 'Password changed successfully!',
            message: 'Head back to login?',
            buttons: [
              {
                text: 'Get me out of here',
                handler: () => {
                    this.navCtrl.pop();
               }
             }
           ]
          });

          confirm.present();
        }
    })
    .catch( error => {
        this.isChanging = false;
        this.recievedError = true;
        console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts